module.exports = __webpack_public_path__ + "resources/img/logo_partner_game_16_m.d776b6c4fc62755febf5a973e3c419b1.png";